import { useEffect, useState } from 'react';

const MOBILE_MQ = '(max-width: 700px)';
const TABLET_MQ = '(max-width: 1024px)';

/**
 * Product count before inline Facebook on a given results page.
 * Page 1: after row 3 on desktop (5 cols), after 8 products on mobile (2 cols).
 * Other odd pages: after row 2 (desktop/tablet) or 6 products (mobile).
 *
 * @param {number} pageNum
 */
export function browseFacebookInsertAfterForPage(pageNum) {
  const isFirstPage = pageNum === 1;
  if (typeof window === 'undefined') {
    return isFirstPage ? 15 : 10;
  }
  if (window.matchMedia(MOBILE_MQ).matches) {
    return isFirstPage ? 8 : 6;
  }
  if (window.matchMedia(TABLET_MQ).matches) {
    return isFirstPage ? 9 : 6;
  }
  return isFirstPage ? 15 : 10;
}

/**
 * Inline Facebook on page 1, 3, 5, … (every other page) at the row offset.
 *
 * @param {number} index
 * @param {number} productsPerPage
 */
export function shouldShowBrowseFacebookInlineAtIndex(index, productsPerPage) {
  const pageNum = Math.floor(index / productsPerPage) + 1;
  const indexInPage = index % productsPerPage;
  if (pageNum % 2 !== 1) {
    return false;
  }
  return indexInPage + 1 === browseFacebookInsertAfterForPage(pageNum);
}

/**
 * @param {number} productCount
 * @param {number} productsPerPage
 */
export function browseFacebookInlineWasShown(productCount, productsPerPage) {
  for (let index = 0; index < productCount; index += 1) {
    if (shouldShowBrowseFacebookInlineAtIndex(index, productsPerPage)) {
      return true;
    }
  }
  return false;
}

/** Re-render when viewport crosses mobile/tablet breakpoints. */
export function useBrowseFacebookInlineLayout() {
  const [, setRevision] = useState(0);

  useEffect(() => {
    const mqMobile = window.matchMedia(MOBILE_MQ);
    const mqTablet = window.matchMedia(TABLET_MQ);

    function sync() {
      setRevision((revision) => revision + 1);
    }

    mqMobile.addEventListener('change', sync);
    mqTablet.addEventListener('change', sync);
    return () => {
      mqMobile.removeEventListener('change', sync);
      mqTablet.removeEventListener('change', sync);
    };
  }, []);
}
